export default __webpack_public_path__ + "static/media/81.5fb7ed6b.png";